module.exports = __webpack_public_path__ + "static/media/HCMM303.88cada78.jpg";